import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { GetInvitationDto } from '@/types/dtos/invitations/response/get-invitation.dto.ts';

export const GET_INVITATION_QUERY_KEY = 'get-invitation';

export const useGetInvitationQuery = (invitationKey: string) => {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: [GET_INVITATION_QUERY_KEY, invitationKey],
    enabled: Boolean(invitationKey),
    queryFn: async () => {
      const token = await getToken();
      return getInvitation({ token: token ?? '', invitationKey });
    },
    retry: false,
  });
};

const getInvitation = async ({
  token,
  invitationKey,
}: {
  token: string;
  invitationKey: string;
}): Promise<GetInvitationDto> => {
  const url = `${import.meta.env.VITE_API_URL}/invitations/${invitationKey}`;
  return sendJSONRequest({ url, method: METHOD.GET, token });
};
